import PropTypes from "prop-types";
import React from "react";
import { Controller } from "react-hook-form";
import { FormGroup, Input, Label } from "reactstrap";
import MessageFormValidateV2 from "../MessageFormValidateV2";

/**
 * @param {object} props
 * @param {object} props.mainForm - react-hook-form instance
 * @param {string} props.fieldName - name of the field in the form
 * @param {function} props.t - translation function
 * @param {boolean} props.isDisabled - whether the switch is disabled
 * @param {boolean} props.isRequired - whether the field is required
 * @param {?function} props.onChange - onChange handler
 * @param {string} props.title - title of the field
 * @param {boolean} props.isLabel - whether to show a label
 * @param {boolean} props.isError - whether to show error message
 */
const FormSwitch = props => {
  const {
    mainForm,
    fieldName,
    t,
    isDisabled,
    isRequired,
    onChange,
    title,
    isLabel,
    isError,
  } = props;

  const {
    formState: { errors },
    control,
    setValue,
    watch,
  } = mainForm;

  const value = watch(fieldName);

  return (
    <div className={`${isLabel ? "mb-3" : ""}`}>
      <Controller
        control={control}
        name={fieldName}
        render={({ field }) => {
          return (
            <FormGroup switch style={{ paddingLeft: 0 }}>
              <div className="form-switch-lg">
                <Label
                  className="form-check-label"
                  htmlFor={fieldName}
                  onClick={() => {
                    field.onChange(!field.value);
                  }}
                >
                  {title || t(`form.${fieldName}`)}{" "}
                  {isRequired && <span className="text-danger">*</span>}
                  <Input
                    type="switch"
                    role="switch"
                    className="form-check-input"
                    disabled={isDisabled}
                    checked={field.value}
                    onChange={e => {
                      field.onChange(e.target.checked);
                      if (onChange) {
                        onChange(e.target.checked);
                      }
                    }}
                  />
                </Label>
              </div>
            </FormGroup>
          );
        }}
      />
      {isError && (
        <MessageFormValidateV2 errors={errors} fieldName={fieldName} />
      )}
    </div>
  );
};

FormSwitch.propTypes = {
  mainForm: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func,
  title: PropTypes.string,
  isLabel: PropTypes.bool,
  isError: PropTypes.bool,
};

FormSwitch.defaultProps = {
  isDisabled: false,
  isRequired: false,
  onChange: undefined,
  title: "",
  isLabel: true,
  isError: true,
};

export default FormSwitch;
